import { render } from "./RoomCamera.vue?vue&type=template&id=5879c66a&scoped=true&ts=true"
import script from "./RoomCamera.vue?vue&type=script&lang=ts"
export * from "./RoomCamera.vue?vue&type=script&lang=ts"

import "./RoomCamera.vue?vue&type=style&index=0&id=5879c66a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/beatout-frontend/beatout-frontend/beatout/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5879c66a"]])

export default __exports__